import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChartLinesLegendLineColorContribution, ChartLinesLegendLineColorProjection, Color, ItemLine, ItemText, Label, LegendCompact, LegendExtended, RowContainer } from './styles';
import { Text } from '../../../Text';
export var LinesLegend = function (_a) {
  var projectionText = _a.projectionText,
    projectionValue = _a.projectionValue,
    contributionText = _a.contributionText,
    contributionValue = _a.contributionValue,
    type = _a.type;
  if (type === 'compact') {
    return _jsxs(LegendCompact, {
      children: [_jsxs(RowContainer, {
        children: [_jsx(Color, {
          line: "projection"
        }), _jsx(Label, {
          el: "div",
          styleName: "bodySmall",
          variant: "secondary",
          children: projectionText
        }), _jsx(Text, {
          styleName: "label",
          el: "div",
          children: projectionValue
        })]
      }), _jsxs(RowContainer, {
        children: [_jsx(Color, {
          line: "contribution"
        }), _jsx(Label, {
          el: "div",
          styleName: "bodySmall",
          variant: "secondary",
          children: contributionText
        }), _jsx(Text, {
          el: "div",
          styleName: "label",
          children: contributionValue
        })]
      })]
    });
  }
  return _jsxs(LegendExtended, {
    children: [_jsxs("div", {
      children: [_jsx(ItemLine, {
        children: _jsx(ChartLinesLegendLineColorProjection, {})
      }), _jsxs(ItemText, {
        children: [_jsx(Text, {
          el: "span",
          styleName: "bodySmall",
          variant: "secondary",
          children: projectionText
        }), _jsx(Text, {
          el: "span",
          styleName: "title7",
          children: projectionValue
        })]
      })]
    }), _jsxs("div", {
      children: [_jsx(ItemLine, {
        children: _jsx(ChartLinesLegendLineColorContribution, {})
      }), _jsxs(ItemText, {
        children: [_jsx(Text, {
          el: "span",
          styleName: "bodySmall",
          variant: "secondary",
          children: contributionText
        }), _jsx(Text, {
          el: "span",
          styleName: "title7",
          children: contributionValue
        })]
      })]
    })]
  });
};